import React from 'react'
import { Modal, GhostButton } from '../../../../../../components'
import { InfoModalBody, InfoModalHeader } from '../InfoModal'

interface FormModalProps {
  setIsOpen: (isOpen: boolean) => void
  isOpen: boolean
}

export const FormModal = (props: FormModalProps) => (
  <Modal open={props.isOpen} toggle={() => props.setIsOpen(false)}>
    <Modal.Header>
      <InfoModalHeader />
    </Modal.Header>
    <Modal.Body>
      <InfoModalBody />
    </Modal.Body>
    <Modal.Footer>
      <GhostButton fullWidth onClick={() => props.setIsOpen(false)}>
        Dismiss
      </GhostButton>
    </Modal.Footer>
  </Modal>
)
